<template>
  <section v-if="activities && activities.length" class="agenda">
    <div class="app-container">
      <h2 class="agenda__judul">Rangkaian Kegiatan</h2>

      <!-- Kartu bernomor yang berjajar, tinggi mengikuti isi (tanpa ruang kosong). -->
      <ol class="agenda__daftar">
        <li v-for="(activity, index) in activities" :key="index" class="agenda__item">
          <span class="agenda__nomor">{{ index + 1 }}</span>
          <div>
            <h3 class="agenda__nama">{{ activity.name }}</h3>
            <p v-if="activity.description" class="agenda__ket">{{ activity.description }}</p>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurActivity',
  props: {
    activities: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.agenda {
  padding: var(--space-8, 32px) 0;
  background-color: var(--bg-surface);
}

.agenda__judul {
  font-family: var(--font-display);
  font-size: clamp(1.3rem, 4vw, 1.75rem);
  margin: 0 0 var(--space-5, 20px);
  color: var(--text-primary);
}

.agenda__daftar {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-3, 12px);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
}

.agenda__item {
  display: flex;
  gap: var(--space-3, 12px);
  align-items: flex-start;
  padding: var(--space-4, 16px);
  background: var(--bg-base);
  border: 1px solid var(--border-subtle);
  border-left: 3px solid var(--accent, #eb5e28);
  border-radius: var(--radius-lg, 12px);
}

.agenda__nomor {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: var(--text-sm, .875rem);
  background: var(--accent-subtle, rgb(235 94 40 / .12));
  color: var(--accent, #eb5e28);
}

.agenda__nama {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  margin: 2px 0 4px;
  color: var(--text-primary);
}

.agenda__ket {
  margin: 0;
  font-size: var(--text-sm, .9rem);
  line-height: 1.5;
  color: var(--text-secondary);
}
</style>
